import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExhibitorType } from "../../../types/ScientificModule";

const initialState: ExhibitorType = {
    id: "",
    idStudent: "",
    idUser: "",
    status: false,
    user: {
        id: undefined,
        name: "",
        userName: "",
        email: "",
        bi: "",
        nuit: "",
        phoneNumber: "",
        dateOfBirth: "",
        gender: "M",
        role: undefined,
        icon: undefined,
        lockoutEnabled: undefined,
        password: undefined,
        roles: undefined,
        claims: undefined
    },
    address: ""
};

const exhibitorsSlice = createSlice({
    name: "exhibitors",
    initialState,
    reducers: {
        setExhibitorsData: (state, action: PayloadAction<ExhibitorType>) => ({ ...state, ...action.payload }),
        resetExhibitorsData: () => ({ ...initialState }),
    },
});

export const { setExhibitorsData, resetExhibitorsData } = exhibitorsSlice.actions;

export default exhibitorsSlice.reducer;
